// extracted by mini-css-extract-plugin
module.exports = {"siteNotifications":"SiteNotification_siteNotifications__aP2FS"};